import { LocalStorageService } from '../LocalStorageService'
import { Browser } from '../helpers/Browser'

export const Affiliate = {

    allowedTagNames: ['btag', 'affid', 'qtag', 'operatorId'],
    regUrlKey: 'regUrl',
    registerTags: () => {
        Affiliate.allowedTagNames.forEach(tagName => {
            const tagValue = Browser.getURLParamValue(tagName)
            if (tagValue) {
                Affiliate.setTag(tagName, tagValue)
            }
        })

        Affiliate.setRegUrl();
    },

    /** Set affiliate registration url for specified time duration in local storage
     * @param {int } duration time duration 
     */
    setRegUrl: (duration = 1) => {

        const absoluteUrl = Browser.getAbsoluteUrl().toLowerCase();
        const queryString = Browser.getUrlQueryString();

        if (queryString /*&& absoluteUrl.includes('/registration')*/) {
            const date = new Date();
            const expirationDate = new Date(date.setDate(date.getDate() + duration)).toLocaleString('en-US');
            const regUrl = {
                [Affiliate.regUrlKey]: encodeURIComponent(absoluteUrl),
                expirationDate
            }
            LocalStorageService.set(Affiliate.regUrlKey, regUrl);
        }
    },

    /** Get affiliate registration url for specified time duration in local storage*/
    getRegUrl: () => {

        const regUrl = LocalStorageService.get(Affiliate.regUrlKey);

        if (Affiliate.isThereActiveRecord(Affiliate.regUrlKey)) {
            return regUrl[Affiliate.regUrlKey];
        }
        return null;
    },

    /** Set affiliate's tag for specified time duration in local storage
     * @param {string } tagName Affiliate's tag name
     * @param {string } tagValue Affiliate's tag value
     * @param {int } duration time duration 
     * @param {int } unit time duration unit - seconds, minutes, days
     */
    setTag: (tagName, tagValue, duration = 30) => {
        const date = new Date();
        const expirationDate = new Date(date.setDate(date.getDate() + duration)).toLocaleString('en-US');
        const affilate = {
            [tagName]: tagValue,
            expirationDate
        }
        LocalStorageService.set(tagName, affilate);
    },

    /** Get affiliate's tag for specified time duration from local storage
     * @param {string } tagName Affiliate's tag name
     * @return {string} Affiliate's tag object if exists otherwise returns null
     */
    getTag: (tagName) => {
        const affilate = LocalStorageService.get(tagName);

        if (Affiliate.isThereActiveRecord(tagName)) {
            return affilate[tagName];
        }

        return null;
    },

    /** Check if there is active tag in local storage
     * @param {string } tagName Affiliate's tag name
     * @return {bool} returns true if there is valid tag, if tag is not valid removes it from locl storage
    */
    isThereActiveRecord: (tagName) => {
        const affilate = LocalStorageService.get(tagName);
        if (affilate) {
            const now = new Date();
            const expirationDate = new Date(affilate.expirationDate);
            let isValid = now.getTime() < expirationDate.getTime();
            if (!isValid) {
                //remove tag if its not ivalid anymore
                LocalStorageService.remove(tagName);
            }
            return isValid;
        }

        return false;
    },
    isThereAnyActiveTag: () => {
        let result = false;
        Affiliate.allowedTagNames.forEach(tagName => {
            if (Affiliate.isThereActiveRecord(tagName)) {
                result = true;
                return;
            }
        })
        return result;
    },
    /** Remove tag from local storage */
    removeTag: (tagName) => {
        LocalStorageService.remove(tagName);
    }
}
